import React, { useEffect,useReducer, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, Space, Upload ,UploadProps, InputNumber, Table, Radio} from 'antd';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Brands, BrandsRequest, CategoryItemReq, ItemCategoryRequest, ItemForBrandReq, ItemRequest, ItemsDropDownDto, ItemSubCategoryDropDownDto, MasterBrandDto, MasterBrandsDropDownDto, SizesDropDownDto, SubCatReqForCategoryId } from '@gtpl/shared-models/masters';
import { ItemsService, ItemSubCategoryService, MasterBrandService, SizesService } from '@gtpl/shared-services/masters';
import { PackingCategoryEnum,ConversionType, UnitRequest } from '@gtpl/shared-models/common-models';
import { StockService } from '@gtpl/shared-services/procurement';
import { StockDTO } from '@gtpl/shared-models/warehouse-management';
import { PlantItemSubCategoryIdReq, ProductConversionModel, SaleOrderIdRequest, StockDto } from '@gtpl/shared-models/procurement-management';
const {Option} = Select;
export interface PackingProductConversionProps {
    isUpdate: boolean;
    closeForm: () => void;
 }
export function PackingProductConversion(
     props:PackingProductConversionProps
){


    const [form] = Form.useForm();
    const [soDropDown,setSoDropDown] = useState<any>()
    const [toSoDropDown,setToSoDropDown] = useState<any>()
    const [disable,setDisable] =useState<boolean>(false)
    const [soItemdropDown,setSoItemDropdown] = useState<any>()
    const [toSoItemdropDown,setToSoItemDropdown] = useState<any>()
    const stockService = new StockService;
    const [conversionType,setConversionType] = useState<ConversionType>()
    const createdUser = localStorage.getItem('createdUser')
    const fromItemId = form.getFieldValue('fromSaleOrderItemId')
    
    

    useEffect (()=>{
      //  getItemData()
       getSoDropDown()
    },[])


 
  const getAvailableQtyforFromItem = (value) => {
    form.resetFields(['toSaleOrderId','toSaleOrderItemId','toStockId','fromQuantity','toQuantity','conversionQuantity','reason'])
    const unitId = Number(localStorage.getItem('unit_id'))
    const req = new ItemRequest(value,unitId,form.getFieldValue('fromSaleOrderId'));
    stockService.getPhysicalQuantityForItemId(req).then(res => {
      if(res.status){
        form.setFieldsValue({fromQuantity : res.data[0].physicalQuantity,fromStockId : res.data[0].stockId})

      }
    })
  }    

  const getAvailableQtyforToItem = (value) => {
    
    const unitId = Number(localStorage.getItem('unit_id'))
    const req = new ItemRequest(value,unitId,form.getFieldValue('toSaleOrderId'));
    stockService.getPhysicalQuantityForItemId(req).then(res => {
      if(res.status){
        console.log( res.data,'--qty')
        form.setFieldsValue({toQuantity : res.data[0].physicalQuantity,toStockId : res.data[0].stockId})
      }
    })
  }    
    
 const getSoDropDown = () => {
   const req = new UnitRequest(Number(localStorage.getItem('unit_id')))
   stockService.getStockAvailSos(req).then((res) => {
     if(res.status){
       setSoDropDown(res.data)
     }else{
       setSoDropDown([])
       AlertMessages.getErrorMessage(res.internalMessage)
     }
   })
 }

 const getToSoDropDown = () => {
  const req = new PlantItemSubCategoryIdReq
  req.unitId = Number(localStorage.getItem('unit_id'))
  req.itemSubCategoryId = soItemdropDown.find(i => i.itemId == form.getFieldValue('fromSaleOrderItemId')).itemSubCategoryId
  stockService.getPoNumberForProductConversion(req).then((res) => {
    if(res.status){
      setToSoDropDown(res.data)
    }else{
      setToSoDropDown([])
      AlertMessages.getErrorMessage(res.internalMessage)
    }
  })
 }

 const getFromSoItemDroDown = (value) => {
  form.resetFields(['fromSaleOrderItemId','fromStockId','toSaleOrderId','toSaleOrderItemId','toStockId','fromQuantity','toQuantity','conversionQuantity','reason'])

   form.resetFields(['fromSaleOrderItemId','fromQuantity'])
   const req = new SaleOrderIdRequest(value,Number(localStorage.getItem('unit_id')));
   stockService.getavailbleItemsInStock(req).then((res) => {
    if(res.status){
      setSoItemDropdown(res.data)
    }else{
      setSoItemDropdown([])
      AlertMessages.getErrorMessage(res.internalMessage)
    }
   })
 }

 const getToSoItemDroDown = (value) => {
  form.resetFields(['toSaleOrderItemId','toQuantity'])
  const fromItemSubCatgeoryId = soItemdropDown.find(i => i.itemId == form.getFieldValue('fromSaleOrderItemId')).itemSubCategoryId
  const req = new SaleOrderIdRequest(value,Number(localStorage.getItem('unit_id')),fromItemSubCatgeoryId);
  stockService.getavailbleItemsInStock(req).then((res) => {
   if(res.status){
     setToSoItemDropdown(res.data)
   }else{
     setToSoItemDropdown([])
     AlertMessages.getErrorMessage(res.internalMessage)
   }
  })
}

 const handleConversionType = (value) => {
   setConversionType(value)
   form.resetFields(['fromSaleOrderId','fromSaleOrderItemId','fromStockId','toSaleOrderId','toSaleOrderItemId','toStockId','fromQuantity','toQuantity','conversionQuantity','reason'])
 }

  const onReset = () => {
    console.log('');
    form.resetFields();

  }

      const onChange=(pagination, filters, sorter, extra)=> {
        console.log('params', pagination, filters, sorter, extra);
      }
      const onFocus = () => {
        //console.log('focus');
      }
    
      const onSearch = (val) => {
        //console.log('search:', val);
      }
      const onBlur = () => {
        //console.log('blur');
      }


      const convertProduct = (values:ProductConversionModel) => {
        setDisable(true)
       if(form.getFieldValue('conversionQuantity') < form.getFieldValue('fromQuantity')){
          stockService.stockConversion(values).then((res) => {
            setDisable(false)
            console.log
            if(res.status){
              form.resetFields()
              AlertMessages.getSuccessMessage('Stock converted sucessfully')
             
            }else{
              AlertMessages.getErrorMessage(res.internalMessage)
            }
          }).catch((err) =>{
            setDisable(false)
              AlertMessages.getErrorMessage(err.message)
          });
        }else{
          AlertMessages.getInfoMessage('Conversion Qty should be less than Converting Items Qty')
        }
       }

    return (
        
         <Card size="small" title={<span style={{ color: 'white' }}>Product Conversion</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} >
        <Form form={form} layout='vertical' name='control-hooks' onFinish={convertProduct}>
          <Row gutter={24} >
          <Form.Item style={{display:"none"}} name="createdUser" initialValue={createdUser} >
            <Input hidden/>
         </Form.Item>         
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} >
              <Form.Item
                label="Conversion Type"
                name={'conversionType'}
                rules={[{ required: true, message: 'Missing Conversion type' }]} >
               <Select
                placeholder="Select Conversion type"
                allowClear
                showSearch
                onSelect={(value) => {handleConversionType(value)}}
                onFocus={onFocus}
                onSearch={onSearch}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
               {Object.values(ConversionType)?.map(item => {
                  return <Option value={item} >{item}</Option>
                })}
              </Select>
              </Form.Item>
            </Col>
           
            <Col xs={{ span: 24}} sm={{ span: 24 }} md={{ span: 4  }} lg={{ span: 4 }} xl={{ span: 4 }} >
            <Form.Item
              name="fromSaleOrderId"
              label=" From PO Number"
              rules={[
                {
                  required: true,
                  message: 'PO Number is required',
                },
               
              ]} >
              <Select
                showSearch
                placeholder="Select PO Number"
                optionFilterProp="children"
                onSelect={(value) => {getFromSoItemDroDown(value)}}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                
                {(form.getFieldValue('conversionType') == ConversionType.saleorder_to_saleorder || form.getFieldValue('conversionType') == ConversionType.saleorder_to_bulk) ? soDropDown?.map((item) => {
                  return <Option  value={item.saleOrderId}>{item.poNumber}</Option>
                }): <Option  value={0}>{"BULK"}</Option> }
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10  }} lg={{ span: 10 }} xl={{ span: 10 }}>
            <Form.Item
              name="fromSaleOrderItemId"
              label="Item"
              rules={[
                {
                  required: true,
                  message: 'Item is required',
                },
               
              ]}>
              <Select
                showSearch
                // style={{ width: 240 }}
                placeholder="Select Item"
                optionFilterProp="children"
                onSelect={(value) => {getAvailableQtyforFromItem(value);getToSoDropDown()}}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                
                {soItemdropDown?.map((item) => {
                  return <Option key={item.itemId} value={item.itemId}>{item.itemName}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} >
              <Form.Item
                name="fromQuantity"
                label="Available Qty"
                rules={[
                  {
                    required: true,
                    message: 'Item is required',
                  },
                ]}
             
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} style={{display:'none'}} >
              <Form.Item
                name="fromStockId"
                 rules={[
                  {
                    required: true,
                    message: 'Item is required',
                  },
                ]}
             
              >
                <Input disabled hidden />
              </Form.Item>
            </Col>
         {
           form.getFieldValue('fromSaleOrderId') >= 0 ? 
         <>
         <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4  }} lg={{ span: 4 }} xl={{ span: 4 }} >
            <Form.Item
              name="toSaleOrderId"
              label=" To PO Number"
              rules={[
                {
                  required: true,
                  message: 'PO Number is required',
                },
               
              ]}>
              <Select
                showSearch
                // style={{ width: 240 }}
                placeholder="Select PO Number"
                optionFilterProp="children"
                onSelect={(value) => {getToSoItemDroDown(value)}}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                
                {(form.getFieldValue('conversionType') == ConversionType.saleorder_to_saleorder || form.getFieldValue('conversionType') == ConversionType.bulk_to_saleorder) ? soDropDown?.filter(i => i.saleOrderId != form.getFieldValue('fromSaleOrderId') )?.map((item) => {
                  return <Option  value={item.saleOrderId}>{item.poNumber}</Option>
                }) :  <Option  value={0}>{'BULK'}</Option> }
              </Select>
            </Form.Item>
          </Col>
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10  }} lg={{ span: 10 }} xl={{ span: 10 }}>
           <Form.Item
             name="toSaleOrderItemId"
             label="Item"
             rules={[
               {
                 required: true,
                 message: 'Item is required',
               },
              
             ]}>
             <Select
               showSearch
               // style={{ width: 240 }}
               placeholder="Select Item"
               optionFilterProp="children"
               onBlur={onBlur}
               onSelect={(value) => {getAvailableQtyforToItem(value);}}
               onSearch={onSearch}
               filterOption={(input, option) =>
                 option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
               }
             >
               
               {toSoItemdropDown?.map((item) => {
                 return <Option  value={item.itemId}>{item.itemName}</Option>
               })}
             </Select>
           </Form.Item>
         </Col>
         <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 3 }} lg={{ span: 3 }} xl={{ span: 3 }} >
              <Form.Item
                name="toQuantity"
                label="Available Qty"
                rules={[
                  {
                    required: true,
                    message: 'Item is required',
                  },
                ]}
             
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 3 }} lg={{ span: 3 }} xl={{ span: 3 }} style={{display:'none'}} >
              <Form.Item
                name="toStockId"
              >
                <Input disabled hidden />
              </Form.Item>
            </Col>
          </> :''
         }
         <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 3 }} lg={{ span: 3 }} xl={{ span: 3 }} >
              <Form.Item
                name="conversionQuantity"
                label="Conversion Qty"
              rules={[
                {
                  required: true,
                  message:'Conversion Quantity is required',
                  
                },{
                  validator: (_, value) => {
                    const fromQty = form.getFieldValue('fromQuantity')
                    let alertmessage = ''
                    if(value > fromQty){
                      alertmessage = 'Conversion Qty should be less than Converting Items Qty'
                    }
                    if (fromQty) {
                      return value <= fromQty ? Promise.resolve() : Promise.reject(new Error(alertmessage));
                    } else {
                      return Promise.resolve();
                    }
      
                  }
                }
                
              ]}
              >
                <InputNumber style={{width:'100%'}} />
              </Form.Item>
            </Col>
           
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} >
              <Form.Item
                name="reason"
                label="Reason"
                rules={[
                  {
                    required: false,
                    message:'Reason is required',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} >
              <Form.Item
                name="remarks"
                label="Remarks"
                rules={[
                  {
                    required: false,
                    message:'Remarks is required',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
         </Row>
          <Row justify='end'>
            
            <Col span={4} style={{ textAlign: 'right',paddingTop:'30px'}}>
                <Button type="primary" disabled={disable} htmlType="submit"  >
                        Submit
                  </Button>
            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                        Reset
                  </Button>
                  
              </Col>
                
          </Row>
          </Form>
          <br/><br/>
          
      
      
          
         </Card>
        

    );
}

export default PackingProductConversion;